import { instance } from "./../apiclient";

export async function getDeliveryZone(storeId, lat, lng, date, timezone) {
  return instance.post("/delivery/validate-delivery-address/delivery-zone", {
    storeId: storeId,
    deliveryAddressLatLng: [lat, lng],
    currentDate: date,
    timezone: timezone,
  });
}
